<template>
  <div>
    <list-template
      isDownload
      :search-config="searchConfig"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :loading="loading"
      :current-page="page"
      @onExportData="handDownload"
      @onAdd="handAdd"
      @onHandle="handleClick"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChangePage="handleCurrentChange"
      @onChange="onChange"
    />
    <Dialog :visible.sync="showDialog" :closeOnClickModal="false" :showFooter="false" title="创建问卷" size="small" :beforeClose="onBeforeClose">
      <el-form ref="form" :model="formData" :rules="rules">
        <el-form-item prop="pay_time" label-width="0">
          <div class="flex justify-between">
            <el-select v-model="formData.pay_time" placeholder="请选择辅导周期">
              <el-option v-for="item in options" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" @click="handleAction(0)">生成连接</el-button>
          </div> 
        </el-form-item>
        <el-form-item>
          <el-input type="textarea" v-model="formData.url" placeholder="" rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div class="flex-center">
        <el-button class="mr-2" type="primary" @click="handleAction(1)">复制链接</el-button>
        <el-button type="primary" @click="handleAction(2)">下载二维码</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import { tableListMixin } from '@/utils/mixins'
import http, { fileDownload } from '@/api'
import { setConfigOption, getConfigValue, setConfigValue, handleDownFile } from '@/utils'
import { copyText } from '@/utils'
export default {
	_config:{'route':{'path':'list','meta':{'title':'列表','keepAlive':true}}},
  mixins: [tableListMixin],
  components: { Dialog },
  data() {
    return {
      showDialog: false,
      searchConfig: [
        { placeholder: '筛选辅导周期', prop: 'month', tag: 'select', options: [] },
        { placeholder: '筛选校区', prop: 'school_id', tag: 'select', options: [], change: (id, search) => {
          if (search.class_id) search.class_id = ''
          this.getClass(id, search.grade_id)
        }},
        { placeholder: '筛选年级', prop: 'grade_id', tag: 'select', options: [], change: (id, search) => {
          if (search.class_id) search.class_id = ''
          this.getClass(search.school_id, id)
        }},
        { placeholder: '筛选班级', prop: 'class_id', tag: 'select', options: [], config: { 'no-data-text': '请先选择校区和年级' } },
      ],
      tableConfig: [
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'student_no', label: '学号' },
        { prop: 'day_describe', label: '辅导周期' },
        { prop: 'total_score', label: '分值' },
        { prop: 'school_name', label: '校区' },
        { prop: 'grade_name', label: '年级' },
        { prop: 'class_name', label: '班级' },
        { prop: 'created_at', label: '提交时间' },
        { label: '操作', width: '100rem', handle: true }
      ],
      formData: { pay_time: '', url: '' },
      rules: {
        pay_time: [{ required: true, message: '请选择辅导周期', trigger: 'change' }]
			},
      options: []
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      this.getDate()
      this.getSchool()
      this.getGrade()
    },
    getDate() {
      http({ url: '/teacher/moral-stu-evaluation/get-cycle', pre: 'api2'}, { size: 10 }).then(res => {
        if(!res) return
        const data = res.map(item => ({ value: item.day_start + '-' + item.day_end, label: item.day_start + '-' + item.day_end }))
        this.options = data
        setConfigOption({ list: this.searchConfig, data, key: 'month' })
      })
    },
    getSchool() {
      http({ url: '/recruit/common/consulting-school', pre: 'zs' }).then(res => {
        const arr = res.entity_school || []
        const data = arr.map(item => ({ value: item.id, label: item.school_name }))
        data.unshift({ value: '0', label: '全部' })
        setConfigOption({ list: this.searchConfig, data, key: 'school_id' })
      })
    },
    getGrade() {
      http({ url: '/site/grades', pre: 'api1' }).then(res => {
        const data = res.map(item => ({ value: item.id, label: item.name }))
        data.unshift({ value: '0', label: '全部' })
        setConfigOption({ list: this.searchConfig, data, key: 'grade_id' })
      })
    },
    getClass(school_id, grade_id) {
      if (!grade_id || !school_id) return
      http({ url: '/site/role-admin-class', pre: 'api1' }, { grade_id, school_id }).then(res => {
        const data = res.map(item => ({ value: item.class_id, label: item.class_name }))
        setConfigOption({ list: this.searchConfig, data, key: 'class_id' })
      })
    },
    async getData() {
      this.getDataApi('/api2/api/teacher/moral-stu-evaluation/get-evaluation-list')
    },
    onBeforeSearch(val) {
      const { month, ...other } = val
      const data = { ...other }
      if (month) {
        const [start, end] = month.split('-')
        data.day_start = start
        data.day_end = end
      }
      this.search = data
    },
    onBeforeInit() {
      const { student_name, school_id } = this.$route.query
      const id = Number(school_id)
      if (student_name) {
        this.page = 1
        setConfigValue({ list: this.searchConfig, key: 'student_name', changeKey: 'default', value: student_name })
        setConfigValue({ list: this.searchConfig, key: 'school_id', changeKey: 'default', value: id })
        this.search.student_name = student_name
        this.search.school_id = id
      }
    },
    onBeforeReset() {
      if (getConfigValue({list: this.searchConfig, key: 'student_name', valueKey: 'default'})) {
        setConfigValue({ list: this.searchConfig, key: 'student_name', changeKey: 'default' })
        setConfigValue({ list: this.searchConfig, key: 'school_id', changeKey: 'default' })
        this.$router.replace('./list')
      }
      setConfigOption({ list: this.searchConfig, data: [], key: 'class_id' })
      this.search = {}
      this.tableData = []
    },
    handleClick(row) {
      this.$router.push(`./detail?id=${row.id}`)
    },
    handDownload() {
      fileDownload('/api2/api/teacher/moral-stu-evaluation/export-evaluation-list', {}, { name: '调查问卷 ', show: true })
    },
    handAdd() {
      this.showDialog = true
    },
    handleAction(type) {
      if (type === 1) {
        if (!this.formData.url) return this.$message.warning('请先生成链接')
        copyText(this.formData.url)
      } else if (type === 2) {
        if (!this.formData.url) return this.$message.warning('请先生成链接')
        const url = process.env.VUE_APP_URL_THREE + '/api/qrcode?url=' + encodeURIComponent(this.formData.url)
        handleDownFile({ url })
      } else {
        if (!this.formData.pay_time) return this.$message.warning('请选择辅导周期')
        this.formData.url = process.env.VUE_APP_URL_QUESTION + '/moral/index/1?date=' + this.formData.pay_time
      }
    },
    onBeforeClose(done, instance) {
      if (instance.type !== 'submit') {
        return done()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
